import { Modal, Form, Select } from 'antd';
import { usePostProjectAccessUserIdMutation } from '../features/api/apiSlice';

export default function AccessEdit(props) {
  const { open, setOpen, projectId, form } = props;
  const [postProjectAccessUserId, { isLoading }] = usePostProjectAccessUserIdMutation();

  const handleEdit = () => {
    form
      .validateFields()
      .then(async (values) => {
        const { role, user_id } = values;
        await postProjectAccessUserId({ role, projectId, userId: user_id }).unwrap();
        setOpen(false);
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  return (
    <Modal
      open={open}
      title="Edit Access"
      okText="Save"
      cancelText="Cancel"
      centered
      onCancel={() => {
        form.resetFields();
        setOpen(false);
      }}
      onOk={handleEdit}
      okButtonProps={{ loading: isLoading }}
      styles={{
        header: { padding: '20px 24px 0', marginBottom: 0 },
        body: { padding: '16px 24px 8px' },
        footer: { padding: '8px 24px 20px' },
      }}
    >
      <Form form={form} layout="vertical" style={{ marginTop: 8 }}>
        <Form.Item
          name="role"
          label="Role"
          rules={[{ required: true, message: 'Please select a role' }]}
        >
          <Select placeholder="Please select role" size="large">
            <Select.Option value="ProjectManager">Project Manager</Select.Option>
            <Select.Option value="SiteEngineer">Site Engineer</Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
}
